var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15zm0 1.25a8.75 8.75 0 100-17.5 8.75 8.75 0 000 17.5z",
    fill: "#255500"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.236 6.647l-.884-.884L10 9.116 6.647 5.763l-.883.884L9.116 10l-3.352 3.353.883.884L10 10.883l3.352 3.354.884-.884L10.884 10l3.352-3.353z",
    fill: "#255500"
  })));
}

export default SvgIconClear;